
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Button, Form } from "react-bootstrap"
import Cropper from 'react-easy-crop'
import { rotateImage } from "../../utils/ImageUtil"
import "../../css/CropperModal.css"
import { ReactComponent as Clockwise } from '../../icon/rotate-right.svg'
import { ReactComponent as CounterClockwise } from '../../icon/rotate-left.svg'
import { Area } from 'react-easy-crop/types'
import FaceGuide from "../../image/face-guide.png"

interface CropperModalProps {
  show: boolean
  showFaceGuide: boolean
  image: string
  onClose: () => void
  finishCrop: (cropRect: Area, image: string) => void
}

function CropperModal({ show, showFaceGuide, image, onClose, finishCrop }: CropperModalProps) {
  const [rotatedImage, setRotatedImage] = useState<string | null>(null)
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState<number>(1)
  const [cropRect, setCropRect] = useState<Area>({ x: 0, y: 0, width: 1, height: 1 })

  const { t } = useTranslation()

  const getImg = () => {
    const img = new Image()
    img.src = rotatedImage || image
    return img
  }

  const rotate = (degrees: number) => {
    setRotatedImage(
      rotateImage(getImg(), degrees)
    )
  }

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static" dialogClassName="cropperModal">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {t("crop.heading")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="cropContainer">
          <Cropper
            image={rotatedImage || image}
            crop={crop}
            zoom={zoom}
            aspect={1}
            rotation={0}
            showGrid={!showFaceGuide}
            style={{ cropAreaStyle: showFaceGuide ? { background: `url(${FaceGuide}) no-repeat center center`, backgroundSize: "cover" } : {}}}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={(cropRelative, cropRect) => setCropRect(cropRect)}
          />
        </div>
        <div className="cropControls">
          <Form.Control
            type="range"
            value={zoom}
            min={1}
            max={3}
            step={0.1}
            onChange={(e) => setZoom(parseFloat(e.target.value))}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="smpl" className="float-left rotateControl" onClick={() => rotate(-90)}>
          <CounterClockwise />
        </Button>
        <Button variant="smpl" className="float-left rotateControl" onClick={() => rotate(90)}>
          <Clockwise />
        </Button>
        <Button variant="smpl" className="float-right" onClick={() => finishCrop(cropRect, rotatedImage || image)}>
          {t("crop.save")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CropperModal